import { css } from "@emotion/react";
import { MsgPosition } from "components/chat/types";

export const bubbleStyle = {
  root: (position: MsgPosition) => css`
    display: flex;
    margin-bottom: 16px;
    ${position === "right" &&
    `
      justify-content: flex-end;
    `}
  `,
  child: css`
    max-width: 80%;
  `,
  box: (position: MsgPosition) => css`
    display: flex;
    ${position === "right" &&
    `
      justify-content: flex-end;
    `}
  `,
};
